import * as moment from 'moment';

function validarData(data) {
    if (data != "" && data != null)
    {
        var dateToValidate = moment(data, 'DD/MM/YYYY', true)
        if (!dateToValidate.isValid())
            return 'Data Inválida!'
    }

    return true
}

function validarDataFutura(data) {
    if (data != "")
    {
        var dtAtual = new Date
        var dateToValidate = moment(data, 'DD/MM/YYYY', true)
        if(dateToValidate > dtAtual)
            return 'Data deve ser menor ou igual a data atual!'
    }

    return true
}

function validarDataAnteriorAtual(data) {
    if (data != "")
    {
        var dtAtual = new Date
        dtAtual = moment(dtAtual.toLocaleDateString('pt-br'), 'DD/MM/YYYY', true)
        var dateToValidate = moment(data, 'DD/MM/YYYY', true)
        if(dtAtual > dateToValidate)
            return 'Data deve ser maior ou igual a data atual!'
    }

    return true
}

function validarDataFuturaTrintaDias(data) {
    if (data != "")
    {
        var targetDate = new Date()
        targetDate.setDate(targetDate.getDate() + 30)
        var dateToValidate = moment(data, 'DD/MM/YYYY', true)
        if(dateToValidate > targetDate)
            return 'Data deve ser inferior a ' + targetDate.toLocaleDateString('pt-br') + '!'
    }

    return true
}

function validarHora(valor){
    if (valor!= undefined && valor != null){
        var hora = valor.substring(0,2) || -1
        var minuto = valor.substring(3,5) || -1
        if (hora >=0 && hora < 24) {
            if (minuto >=0 && minuto < 60) {
                return true
            }
        }
    }
    return "Hora inválida"
}

function campoObrigatorio(value) {
    if (value == '' || value == undefined || value.isNaN || value.toString() == 'NaN' || value.toString().trim() == '')
        return 'Campo Obrigatório!'

    return true
}

function campoSelectObrigatorio(value) {
    if (value == undefined || value == 0)
        return 'Campo Obrigatório!'

    return true
}

function campoMaiorZero(value) {
    if (value <= 0)
        return 'Valor deve ser maior que 0.'

    return true
}

function qtdTotalAnimaisMaiorQueZero(value) {
    if (value <= 0)
        return 'Total de animais não pode ser 0.'

    return true
}

function campoMaiorOuIgualZero(value) {
    if (value < 0)
        return 'Valor deve ser maior ou igual a 0.'

    return true
}

function campoCPF(value) {
    // eslint-disable-next-line
    const pattern = /^(([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}))$/

    return pattern.test(value) || 'CPF inválido.'
}

function campoCNPJ(value) {
    // eslint-disable-next-line
    const pattern = /^(([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}))$/

    return pattern.test(value) || 'CNPJ inválido.'
}

function campoCPFouCNPJ(value) {
    if (value == null)
    {
        return 'CPF/CNPJ inválido.'
    }
    
    if (value.length == 14)
    {
        // eslint-disable-next-line
        const pattern = /^(([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}))$/

        return pattern.test(value) || 'CPF inválido.'
    }
    if (value.length > 14)
    {
        // eslint-disable-next-line
        const pattern = /^(([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}))$/

        return pattern.test(value) || 'CNPJ inválido.'
    }

    return 'CPF/CNPJ inválido.'
}

function campoCelular(value) {
    const pattern = /^(([0-9]{11}))$/

    return pattern.test(value) || 'Celular inválido.'
}

function campoEmail(value) {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (value == "" || value == undefined)
        return true
            
    return pattern.test(value) || 'E-mail inválido.'
}

function isAValidFloat(value) {
    return /^[0-9]{1,9}([.,][0-9]{1,3})?$/.test(value) || 'Valor inválido.'
}

function tamanhoMaximoCinco(value) {
    if (value && value.length > 5)
        return 'Valor deve ser menor que 5!'

    return true
}

function tamanhoMaximoOito(value) {
    if (value && value.length > 8)
        return 'Valor deve ser menor que 8!'

    return true
}

function data1InferiroData2(data1, data2) {
    if (data1 > data2)
        return false

    return true
}

function data1DepoisOuIgualDeData2(data1, data2) {
    if (moment(data1, 'DD/MM/YYYY').isSameOrAfter(moment(data2, 'DD/MM/YYYY')))
        return true

    return false
}

function tamanhoMaximoDezesseis(value) {
    if (value && value.length > 16)
        return 'Valor deve ser menor que 16!'

    return true
}

function tamanhoMaximoQuarenta(value) {
    if (value && value.length > 40)
        return 'Valor deve ser menor que 40!'

    return true
}

function tamanhoMaximoTrinta(value) {
    if (value && value.length > 30)
        return 'Valor deve ser menor que 30!'

    return true
}

function tamanhoMaximoVinte(value) {
    if (value && value.length > 20)
        return 'Valor deve ser menor que 20!'

    return true
}

export {
    validarData,
    validarDataFutura,
    campoObrigatorio,
    campoSelectObrigatorio,
    campoMaiorZero,
    qtdTotalAnimaisMaiorQueZero,
    campoMaiorOuIgualZero,
    campoEmail,
    validarHora,
    isAValidFloat,
    tamanhoMaximoCinco,
    validarDataFuturaTrintaDias,
    tamanhoMaximoOito,
    validarDataAnteriorAtual,
    campoCPF,
    campoCelular,
    data1InferiroData2,
    data1DepoisOuIgualDeData2,
    campoCNPJ,
    campoCPFouCNPJ,
    tamanhoMaximoDezesseis,
    tamanhoMaximoQuarenta,
    tamanhoMaximoTrinta,
    tamanhoMaximoVinte,
}
